const testimonialData = [
    {
        id: 1,
        name: 'Godwin Mashiri',
        position: 'Chief Life & Principal Officer',
        company: 'Econet Life (Pvt) Ltd.',
        testimonial: 'Working with Leeroy was a game-changer for our project. His ability to bridge complex technical challenges with elegant solutions is unparalleled.',
        avatar: 'https://d2fcmuoyu5hsuu.cloudfront.net/mashiri.jpg',
        rating: 4
    },
    {
        id: 2,
        name: 'Clayton Murungu',
        position: 'Head of Engineering',
        company: 'Zimbabwe Shared Services',
        testimonial: 'Leeroy is an exceptional full-stack engineer who consistently delivers high-quality, scalable solutions. His technical expertise and problem-solving skills are truly remarkable.',
        avatar: 'https://d2fcmuoyu5hsuu.cloudfront.net/avatar.jpg',
        rating: 5
    },
    {
        id: 3,
        name: 'George Kihara',
        position: 'Senior Software Engineering Manager',
        company: 'Cellulant (Kenya)',
        testimonial: 'Leeroy\'s expertise in microservices and cloud architecture transformed our development process. His code is clean, efficient, and always well-documented.',
        avatar: 'https://d2fcmuoyu5hsuu.cloudfront.net/kihara.jpg',
        rating: 4.5
    }
];

export default testimonialData;